// Generated by `bazel run i18n`. Do not edit by hand.
import home_48172dae from "./en/account--app--src--account--home.json";
import lists_05f113fc from "./en/account--app--src--account--lists.json";
import orders_ef59f554 from "./en/account--app--src--account--orders.json";
import personalInfo_7315117f from "./en/account--app--src--account--personal-info.json";
import warranties_0301789d from "./en/account--app--src--account--warranties.json";
import account_afe6dd13 from "./en/account--app--src--account.json";
import login_fc31d166 from "./en/account--app--src--login.json";
import oms_3534c786 from "./en/orders--app--src--oms.json";
import hooks_5b245a30 from "./en/orders--app--src--order--hooks.json";
import fulfillment_90b045d2 from "./en/orders--app--src--order--order-tracking--fulfillment.json";
import orderTrackingIframes_8301af3a from "./en/orders--app--src--order-tracking-iframes.json";
import order_849bf5b9 from "./en/orders--app--src--order.json";
import chooseRecipient_9fec3697 from "./en/orders--app--src--orders--gift-receipts--create-gift-receipt--choose-recipient.json";
import dispatcher_1258d860 from "./en/orders--app--src--orders--gift-receipts--create-gift-receipt--dispatcher.json";
import selectItems_3a8ee42e from "./en/orders--app--src--orders--gift-receipts--create-gift-receipt--select-items.json";
import share_d2b86d88 from "./en/orders--app--src--orders--gift-receipts--details--share.json";
import details_09c4f89f from "./en/orders--app--src--orders--gift-receipts--details.json";
import manage_fbbea634 from "./en/orders--app--src--orders--gift-receipts--manage.json";
import giftReceipts_478648bf from "./en/orders--app--src--orders--gift-receipts.json";
import hooks_4eace719 from "./en/orders--app--src--orders--hooks.json";
import screens_9b3ebcec from "./en/orders--app--src--orders--hsa-reimburse--screens.json";
import hsaReimburse_3749186e from "./en/orders--app--src--orders--hsa-reimburse.json";
import orderDetails_f2631021 from "./en/orders--app--src--orders--order-details.json";
import returnMethod_ec757f2e from "./en/orders--app--src--orders--return-method.json";
import orders_a86775a3 from "./en/orders--app--src--orders.json";
import actionAuthorize_4abc4675 from "./en/src--action-authorize.json";
import csat_d29dc12e from "./en/src--csat.json";
import customization_1da3bcec from "./en/src--customization.json";
import list_8fd75d5d from "./en/src--list.json";
import login_16c6e00f from "./en/src--login.json";
import additionalClaimDocuments_7125ad03 from "./en/src--portal-four--returns--additional-claim-documents.json";
import dropoffs_b6ebf55d from "./en/src--portal-four--returns--components--dropoffs.json";
import components_bb0632b4 from "./en/src--portal-four--returns--components.json";
import confirmationDisplay_f17a2b1a from "./en/src--portal-four--returns--confirmation-display.json";
import exchangeConversion_aecbbf43 from "./en/src--portal-four--returns--exchange-conversion.json";
import returns_048356d9 from "./en/src--portal-four--returns.json";
import sharedComponents_522eec4e from "./en/src--portal-four--shared-components.json";
import cart_dbeba823 from "./en/src--portal-four--submission--components--cart.json";
import media_a12a7872 from "./en/src--portal-four--submission--components--product-configurator--media.json";
import productOptions_984699c8 from "./en/src--portal-four--submission--components--product-configurator--product-options.json";
import productConfigurator_1f787557 from "./en/src--portal-four--submission--components--product-configurator.json";
import variantPicker_c7ff4e6f from "./en/src--portal-four--submission--components--variant-picker.json";
import components_08c46215 from "./en/src--portal-four--submission--components.json";
import hooks_72f8fafa from "./en/src--portal-four--submission--hooks.json";
import cart_7e0cc0fa from "./en/src--portal-four--submission--screens--cart.json";
import addExchangeItem_a917f6f8 from "./en/src--portal-four--submission--screens--choose-compensation-method--add-exchange-item.json";
import chooseCompensationMethod_6b1d026a from "./en/src--portal-four--submission--screens--choose-compensation-method.json";
import claimDocumentsReturn_53326c07 from "./en/src--portal-four--submission--screens--claim-documents-return.json";
import flowInput_c3ecec8b from "./en/src--portal-four--submission--screens--flow-input.json";
import flowReturn_c6826d61 from "./en/src--portal-four--submission--screens--flow-return.json";
import flow_c2a877a8 from "./en/src--portal-four--submission--screens--flow.json";
import itemDetails_0e103622 from "./en/src--portal-four--submission--screens--item-details.json";
import login_e403f734 from "./en/src--portal-four--submission--screens--login.json";
import merchantFlow_abf7885e from "./en/src--portal-four--submission--screens--merchant-flow.json";
import packagePickup_8b8eb2c7 from "./en/src--portal-four--submission--screens--package-pickup.json";
import merchantOverrides_3df0a245 from "./en/src--portal-four--submission--screens--review--merchant-overrides.json";
import review_2bf15c15 from "./en/src--portal-four--submission--screens--review.json";
import selectItems_6291372f from "./en/src--portal-four--submission--screens--select-items.json";
import shipmentMethod_96ee1469 from "./en/src--portal-four--submission--screens--shipment-method.json";
import shopNow_102d45ee from "./en/src--portal-four--submission--screens--shop-now.json";
import withdrawalReview_3ea844b4 from "./en/src--portal-four--submission--screens--withdrawal-review.json";
import submission_e1b84475 from "./en/src--portal-four--submission.json";
import util_d059057b from "./en/src--util.json";
import components_e16f89f8 from "./en/warranties--app--src--register--components.json";
import hooks_631c1a95 from "./en/warranties--app--src--register--hooks.json";
import screens_5c95bcfc from "./en/warranties--app--src--register--screens.json";
import register_7b902d88 from "./en/warranties--app--src--register.json";
import thirdPartyWarranty_def7b5df from "./en/warranties--app--src--third-party-warranty.json";
import policies_2263052d from "./en/warranties--app--src--warranties--policies.json";
import warranties_45249157 from "./en/warranties--app--src--warranties.json";

export default Object.assign(
  {},
  home_48172dae,
  lists_05f113fc,
  orders_ef59f554,
  personalInfo_7315117f,
  warranties_0301789d,
  account_afe6dd13,
  login_fc31d166,
  oms_3534c786,
  hooks_5b245a30,
  fulfillment_90b045d2,
  orderTrackingIframes_8301af3a,
  order_849bf5b9,
  chooseRecipient_9fec3697,
  dispatcher_1258d860,
  selectItems_3a8ee42e,
  share_d2b86d88,
  details_09c4f89f,
  manage_fbbea634,
  giftReceipts_478648bf,
  hooks_4eace719,
  screens_9b3ebcec,
  hsaReimburse_3749186e,
  orderDetails_f2631021,
  returnMethod_ec757f2e,
  orders_a86775a3,
  actionAuthorize_4abc4675,
  csat_d29dc12e,
  customization_1da3bcec,
  list_8fd75d5d,
  login_16c6e00f,
  additionalClaimDocuments_7125ad03,
  dropoffs_b6ebf55d,
  components_bb0632b4,
  confirmationDisplay_f17a2b1a,
  exchangeConversion_aecbbf43,
  returns_048356d9,
  sharedComponents_522eec4e,
  cart_dbeba823,
  media_a12a7872,
  productOptions_984699c8,
  productConfigurator_1f787557,
  variantPicker_c7ff4e6f,
  components_08c46215,
  hooks_72f8fafa,
  cart_7e0cc0fa,
  addExchangeItem_a917f6f8,
  chooseCompensationMethod_6b1d026a,
  claimDocumentsReturn_53326c07,
  flowInput_c3ecec8b,
  flowReturn_c6826d61,
  flow_c2a877a8,
  itemDetails_0e103622,
  login_e403f734,
  merchantFlow_abf7885e,
  packagePickup_8b8eb2c7,
  merchantOverrides_3df0a245,
  review_2bf15c15,
  selectItems_6291372f,
  shipmentMethod_96ee1469,
  shopNow_102d45ee,
  withdrawalReview_3ea844b4,
  submission_e1b84475,
  util_d059057b,
  components_e16f89f8,
  hooks_631c1a95,
  screens_5c95bcfc,
  register_7b902d88,
  thirdPartyWarranty_def7b5df,
  policies_2263052d,
  warranties_45249157,
);
